
/**
 * ImagoSpinner - the only loading spinner.
 *
 * Loading vocabulary: skeleton where the layout is known (tables, lists, detail
 * panes), spinner only where it is not.
 *
 * @param {Object} props
 * @param {'sm' | 'md' | 'lg'} [props.size='md'] - 16 / 24 / 32px
 * @param {string} [props.className]
 * @param {string} [props.color='text-primary'] - colour class
 */
export function ImagoSpinner({
  size = 'md',
  className = '',
  color = 'text-primary',
  ...rest
}) {
  const sizeStyles = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  const sizeClass = sizeStyles[size] || sizeStyles.md;

  return (
    <svg
      className={`animate-imago-spin flex-shrink-0 ${sizeClass} ${color} ${className}`.trim()}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="status"
      aria-label="Loading"
      {...rest}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export default ImagoSpinner;
